import { z } from "zod"
import { Analytics } from "cookiesConsent/domain/analytics"
import { Customer, Visitor } from "cookiesConsent/domain/visitor"

const userIdKey = `ajs_user_id`
const identityKeys = [userIdKey, `ajs_user_traits`, `ajs_anonymous_id`]

const heldUserIdSchema = z.union([z.string().min(1), z.number()])

export class SegmentAnalytics implements Analytics {
  identify = (visitor: Visitor): void => {
    const traits = {
      email: visitor.email.value,
      hashedEmail: visitor.email.hashed()
    }

    if (visitor instanceof Customer) {
      window?.analytics?.identify?.(visitor.id, traits)
    } else {
      window?.analytics?.identify?.(traits)
    }
  }

  remembersCustomer = (): boolean => {
    try {
      return heldUserIdSchema.safeParse(
        JSON.parse(window.localStorage.getItem(userIdKey) ?? `null`)
      ).success
    } catch {
      return false
    }
  }

  forget = (): void => {
    if (window?.analytics?.instance) {
      this.resetLoadedSegment(window.analytics.instance)
    } else {
      this.removeStoredIdentity()
    }
  }

  private resetLoadedSegment = (instance: { reset: () => void }): void => {
    try {
      instance.reset()
    } catch {
      this.skipFailedReset()
    }
  }

  private removeStoredIdentity = (): void => {
    try {
      identityKeys.forEach(key => window.localStorage.removeItem(key))
    } catch {
      this.skipBlockedStorage()
    }
  }

  private skipBlockedStorage = (): void => {}

  private skipFailedReset = (): void => {}
}
